'use strict';

/**
 * React Flip Move - Polyfills
 * (c) 2016-present Joshua Comeau
 */

if (!Array.prototype.find) {
  Array.prototype.find = function (predicate) {
    if (this === null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-flip-move/lib/polyfills.js
 ** module id = ./node_modules/react-flip-move/lib/polyfills.js
 ** module chunks = 1
 **/